import { useContext } from 'react';
import { ContextePerimetreSites, type ContextePerimetre } from './context';

export function usePerimetre(): ContextePerimetre {
  const contexte = useContext(ContextePerimetreSites);
  if (!contexte) throw new Error('usePerimetre doit être utilisé dans un FournisseurPerimetre');
  return contexte;
}
